import Vue from 'vue'

const components = [
  'CircleShape',
  'VButton',
  'Group',
  'RectShape',
  'LineShape',
  'VTable',
  'VMap',
  'LVText',
  'LProjectName',
  'LVTime',
  'LVTiming',
  'LVCount',
  'LVClock',
  'LTeamCount',
  'LWorkCount',
  'LCompanyName',
  'LSiteCount',
  'LRealTimeCount',
  'LProjectInfo',
  'LRecord',
  'LTable'
]

components.forEach((key) => {
  Vue.component(key, require(`./${key}/Component.vue`).default)
  Vue.component(key + 'Attr', require(`./${key}/Attr.vue`).default)
})

const svgs = ['SVGStar', 'SVGTriangle']

svgs.forEach((key) => {
  Vue.component(key, require(`./svgs/${key}/Component.vue`).default)
  Vue.component(key + 'Attr', require(`./svgs/${key}/Attr.vue`).default)
})
